module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardBrowser"
  }, [_c('div', {
    staticClass: "options"
  }, [_c('vSelect', {
    attrs: {
      "tabindex": "1",
      "options": _vm.allSets,
      "label": "name"
    },
    model: {
      value: (_vm.currentSet),
      callback: function($$v) {
        _vm.currentSet = $$v
      },
      expression: "currentSet"
    }
  })], 1), _vm._v(" "), _c('CardGrid', {
    attrs: {
      "cards": _vm.setCards
    },
    on: {
      "searchAll": _vm.searchAll
    }
  }), _vm._v(" "), _c('LoadingSpinner', {
    attrs: {
      "loading": _vm.setCards.length <= 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea9bd56e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardBrowser.vue
// module id = 137
// module chunks = 0